import React, { Fragment } from 'react';
import { Cell } from 'flexomatic';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import DropdownList from '../../dropdown-list';

import getTranslations from '../translations';

import { PRODUCT_LIST } from '../../../constants';

/**
 * PRODUCT SELECTOR
 * ------------------
 * Used in course-creator copy option top right hand of page
 * Is abstracted to manage growing complexity of components/course-creator
 * Please continue abstraction on further adjustments to prevent components/course-creator becoming unmanageable
 */
const ProductSelector = ({
    intl,
    isDisabled,
    onChangeHandler,
    selectedProduct
}) => {
    /**
     * TRANSLATIONS
     */
    const {
        productSelectorHeadingText,
        productSelectorPlaceholderText
    } = getTranslations({ intl });

    /**
     * FUNCTIONS
     */
    const getOptionsExcludingMathletics = () =>
        /**
         * BUSINESS RULE: We only display dropdown list when selected product IS NOT Mathletics value
         */
        Object.values(PRODUCT_LIST)
            .filter(product => product.id !== PRODUCT_LIST.MATHLETICS.id)
            .map(product => ({ key: product.id, value: product.name }));

    const renderCellContent = () => {
        switch (selectedProduct) {
        case PRODUCT_LIST.MATHLETICS.id: return PRODUCT_LIST.MATHLETICS.name;
        default: return (
            <DropdownList
                disabled={isDisabled}
                name="select-product"
                onChange={onChangeHandler}
                options={getOptionsExcludingMathletics()}
                placeholder={productSelectorPlaceholderText}
                value={selectedProduct}
            />
        );
        }
    };

    return (
        <Fragment>
            <Cell width={[0.15]}>{productSelectorHeadingText}</Cell>
            <Cell width={[0.35]}>
                {renderCellContent()}
            </Cell>
        </Fragment>
    );
};

ProductSelector.propTypes = {
    intl: intlShape.isRequired,
    isDisabled: PropTypes.bool,
    onChangeHandler: PropTypes.func,
    selectedProduct: PropTypes.number
};

export default injectIntl(ProductSelector);



// WEBPACK FOOTER //
// ./app/components/course-creator/product-selector/index.js